/* LKCJ FAQ: no dependencies; multiple instances and Shopify section reloads supported. */
(() => {
  'use strict';
  const globalKey = '__lkcjFaqV2';
  if (window[globalKey]) { window[globalKey].init(document); return; }
  let nextId = 0;
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[’']/g, '').replace(/[^a-z0-9\u4e00-\u9fff]+/g, ' ').trim();
  const canonical = word => ({ batteries:'battery', magazines:'magazine', refunds:'refund', returns:'return', orders:'order', accessories:'accessory' }[word] || word);
  const tokenize = value => normalize(value).split(/\s+/).filter(Boolean).map(canonical);

  function setup(root) {
    if (root.dataset.faqReady) return;
    const search = root.querySelector('.faq-search');
    const select = root.querySelector('.faq-topic-select');
    const status = root.querySelector('.faq-status');
    const heading = root.querySelector('.faq-results-heading');
    const clear = root.querySelector('.faq-clear');
    const reset = root.querySelector('.faq-reset');
    const empty = root.querySelector('.faq-empty');
    const links = [...root.querySelectorAll('.faq-topic')];
    const categories = [...root.querySelectorAll('.faq-category')].map(section => ({
      section, key:section.dataset.category, title:section.dataset.label,
      items:[...section.querySelectorAll('.faq-item')].map(element => ({
        element,
        tokens:tokenize(element.textContent + ' ' + section.dataset.label),
        beforeSearch:element.open
      }))
    }));
    const items = categories.flatMap(category => category.items);
    const uid = `lkcj-faq-${++nextId}`;
    // The Shopify page editor can strip ARIA attributes from page HTML.
    search.setAttribute('aria-label','Search all questions and answers');
    clear.setAttribute('aria-label','Clear search');
    root.querySelector('.faq-nav').setAttribute('aria-label','FAQ topics');
    status.setAttribute('role','status');
    status.setAttribute('aria-live','polite');
    status.setAttribute('aria-atomic','true');
    root.querySelectorAll('svg').forEach(svg => {
      svg.setAttribute('aria-hidden','true');
      svg.setAttribute('focusable','false');
    });
    // The Shopify page editor can strip ARIA attributes from page HTML.
    search.setAttribute('aria-label','Search all questions and answers');
    clear.setAttribute('aria-label','Clear search');
    root.querySelector('.faq-nav').setAttribute('aria-label','FAQ topics');
    status.setAttribute('role','status');
    status.setAttribute('aria-live','polite');
    status.setAttribute('aria-atomic','true');
    root.querySelectorAll('svg').forEach(svg => {
      svg.setAttribute('aria-hidden','true');
      svg.setAttribute('focusable','false');
    });
    root.querySelector('.faq-content').id = `${uid}-results`;
    links.find(link => link.dataset.topic === 'all').href = `#${uid}-results`;
    search.id = `${uid}-search`;
    root.querySelector('.faq-search-label').htmlFor = search.id;
    select.id = `${uid}-topics`;
    root.querySelector('.faq-topic-label').htmlFor = select.id;
    status.id = `${uid}-status`;
    search.setAttribute('aria-describedby', status.id);
    categories.forEach(category => {
      category.section.id = `${uid}-${category.key}`;
      links.find(link => link.dataset.topic === category.key).href = `#${category.section.id}`;
    });
    let active = 'all';
    let searching = false;

    function removeMarks() {
      root.querySelectorAll('mark[data-faq-mark]').forEach(mark => {
        const parent = mark.parentNode;
        mark.replaceWith(document.createTextNode(mark.textContent));
        parent.normalize();
      });
    }
    function highlight(query) {
      const terms = [...new Set(query.split(/\s+/).filter(Boolean))].sort((a,b) => b.length-a.length);
      if (!terms.length) return;
      const pattern = new RegExp(terms.map(term => term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'gi');
      items.filter(item => !item.element.hidden).forEach(item => {
        const walker = document.createTreeWalker(item.element, NodeFilter.SHOW_TEXT, {
          acceptNode:node => node.parentElement.closest('svg') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
        });
        const nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        nodes.forEach(node => {
          const value = node.nodeValue;
          pattern.lastIndex = 0;
          const matches = [...value.matchAll(pattern)];
          if (!matches.length) return;
          const fragment = document.createDocumentFragment();
          let cursor = 0;
          matches.forEach(match => {
            fragment.append(document.createTextNode(value.slice(cursor,match.index)));
            const mark = document.createElement('mark');
            mark.dataset.faqMark = '';
            mark.textContent = match[0];
            fragment.append(mark);
            cursor = match.index+match[0].length;
          });
          fragment.append(document.createTextNode(value.slice(cursor)));
          node.replaceWith(fragment);
        });
      });
    }
    function render() {
      const query = search.value.trim();
      const words = tokenize(query);
      const hasQuery = query.length > 0;
      removeMarks();
      if (hasQuery && !searching) items.forEach(item => { item.beforeSearch = item.element.open; });
      let total = 0;
      categories.forEach(category => {
        let visible = 0;
        let matching = 0;
        category.items.forEach(item => {
          const match = !hasQuery || (words.length > 0 && words.every(word => item.tokens.some(token => token.includes(word))));
          if (match) matching++;
          const show = match && (active === 'all' || active === category.key);
          item.element.hidden = !show;
          item.element.classList.toggle('faq-first-visible', show && visible === 0);
          if (show) { visible++; total++; }
          if (hasQuery) item.element.open = show;
          else if (searching) item.element.open = item.beforeSearch;
        });
        category.section.hidden = visible === 0;
        category.section.querySelector('.faq-section-count').textContent = String(visible);
        links.find(link => link.dataset.topic === category.key).querySelector('.faq-count').textContent = String(matching);
        select.querySelector(`option[value="${category.key}"]`).textContent = `${category.title} (${matching})`;
      });
      searching = hasQuery;
      const allMatches = categories.reduce((sum,category) => sum + Number(links.find(link => link.dataset.topic === category.key).querySelector('.faq-count').textContent),0);
      links.find(link => link.dataset.topic === 'all').querySelector('.faq-count').textContent = String(allMatches);
      select.querySelector('option[value="all"]').textContent = `All questions (${allMatches})`;
      links.forEach(link => {
        if (link.dataset.topic === active) link.setAttribute('aria-current','true');
        else link.removeAttribute('aria-current');
      });
      select.value = active;
      const title = active === 'all' ? 'Frequently asked questions' : categories.find(category => category.key === active).title;
      heading.textContent = hasQuery ? 'Search results' : title;
      const message = hasQuery
        ? `${total} ${total === 1 ? 'answer' : 'answers'} for “${query}”${active === 'all' ? '' : ` in ${title}`}`
        : active === 'all' ? `${items.length} answers. Find yours below.` : `${total} ${total === 1 ? 'answer' : 'answers'} in this topic.`;
      status.textContent = message;
      clear.hidden = !search.value;
      reset.hidden = !hasQuery && active === 'all';
      empty.hidden = total > 0;
      if (hasQuery && words.length) highlight(query);
    }
    function resetAll() {
      search.value = '';
      active = 'all';
      render();
      search.focus({preventScroll:true});
    }
    search.addEventListener('input', () => { active = 'all'; render(); });
    search.addEventListener('search', () => { active = 'all'; render(); });
    search.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); resetAll(); }
      if (event.key === 'Enter') { event.preventDefault(); render(); }
    });
    clear.addEventListener('click', resetAll);
    root.querySelectorAll('[data-reset]').forEach(button => button.addEventListener('click',resetAll));
    root.querySelectorAll('[data-query]').forEach(button => button.addEventListener('click',() => {
      search.value = button.dataset.query;
      active = 'all';
      render();
      search.focus({preventScroll:true});
    }));
    links.forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      active = link.dataset.topic;
      render();
      const content = root.querySelector('.faq-content');
      if (content.getBoundingClientRect().top < 0) content.scrollIntoView({block:'start'});
    }));
    select.addEventListener('change', () => { active = select.value; render(); });
    render();
    root.dataset.faqReady = 'true';
    root.querySelectorAll('[data-faq-enhanced]').forEach(element => { element.hidden = false; });
    root.querySelector('.faq-fallback').hidden = true;
  }
  function init(scope) {
    if (scope.matches?.('[data-lkcj-faq]')) setup(scope);
    scope.querySelectorAll('[data-lkcj-faq]').forEach(setup);
  }
  window[globalKey] = {init};
  init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
